var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"v_tc"},[_vm._v("\r\n  Copyright(C)www.deepcam.cn All Rights Reserved    "+_vm._s(_vm.showLang('publicHome.footer.phone'))+":  0755-61886461"+_vm._s(_vm.showLang('publicHome.footer.shenzhen'))+"/ 027-87001788"+_vm._s(_vm.showLang('publicHome.footer.wuhan'))+"\r\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-74574042","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/public/footer.vue
// module id = null
// module chunks = 